/**
 * Centralized query key definitions for consistent cache management
 */
export const queryKeys = {
  channels: {
    all: ['channels'] as const,
    byProvider: (providerId: number) => 
      [...queryKeys.channels.all, providerId] as const,
    byVersion: (providerId: number, versionId: number) => 
      [...queryKeys.channels.byProvider(providerId), versionId] as const,
  },
  channelNumbers: {
    all: ['channel-numbers'] as const,
    byProvider: (providerId: number) => 
      [...queryKeys.channelNumbers.all, providerId] as const,
    byVersion: (providerId: number, versionId: number) => 
      [...queryKeys.channelNumbers.byProvider(providerId), versionId] as const,
  },
  import: {
    session: (sessionId: number) => 
      ['import', 'session', sessionId] as const,
    progress: (sessionId: number) => 
      ['import', 'progress', sessionId] as const,
  }
} as const; 